import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.ul `
  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const Item = styled.li `
  display: inline;
  margin-right: 12px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.024em;
  color: ${brand.grey.grey20};

  &:nth-last-child(2),
  &:last-child {
    display: inline;
  }

  @media ${from(Device.Tablet)} {
    display: inline;
    font-size: 16px;
  }
`;
const ItemLink = styled.a `
  ${fonts.klavika.regular};

  color: ${brand.black};
  transition: border-color 0.25s ease;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  margin-right: 12px;

  &:hover {
    border-color: ${brand.black};
  }
`;
const CurrentItem = styled.span `
  ${fonts.klavika.bold};
`;
const BreadcrumbStyles = {
    Container,
    Item,
    ItemLink,
    CurrentItem,
};
export default BreadcrumbStyles;
